/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface PublishConfigurationPublishConfigIdRePublishPut$Params {
  'Active-Tenant-Identifier': string;
  publishConfigId: string;
}

export function publishConfigurationPublishConfigIdRePublishPut(http: HttpClient, rootUrl: string, params: PublishConfigurationPublishConfigIdRePublishPut$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, publishConfigurationPublishConfigIdRePublishPut.PATH, 'put');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('publishConfigId', params.publishConfigId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

publishConfigurationPublishConfigIdRePublishPut.PATH = '/publish-configuration/{publishConfigId}/re-publish';
